import { memo, useCallback } from "react";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";

import { COLLECTIONS_PLAN_TYPE } from "../../../consts/planTypes";
import { palette } from "../../../theme/palette";

import {
  getMatrixProfileType,
  heatmapViewSelector,
  isProfileSelectedSelector,
  selectedOverlaySelector,
} from "../../../reducers/matrixProfile/selectors";

import { RouteLabel } from "./RouteLabel";
import { RouteVolumes } from "./RouteVolumes";
import { View } from "../../View";

const useStyles = makeStyles({
  markerContainer: {
    display: "flex",
    flexDirection: "column",
    marginLeft: (props) => (props.leftMargin ? "2px" : "0"),
  },
  container: {
    maxWidth: "86px",
    minWidth: "30px",
    minHeight: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "center",
  },
  arrow: {
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "10px solid white",
  },
  space: {
    width: "10px",
  },
  spacing: {
    padding: "2px",
  },
  routeLabelContainer: {
    height: "26px",
  },
});

export const RouteMarker = memo(
  ({
    routes = [],
    collection = false,
    postcode,
    individual = false,
    showArrow = true,
    leftMargin = false,
    showNoVolume = false,
  }) => {
    const isVolumeOverlayOn = useSelector(selectedOverlaySelector);
    const isHeatmapOn = useSelector(heatmapViewSelector);
    const isProfileSelected = useSelector(isProfileSelectedSelector);
    const profileType = useSelector(getMatrixProfileType);
    const styles = useStyles({ leftMargin });

    const showVolume = useCallback(() => {
      return (
        isVolumeOverlayOn &&
        COLLECTIONS_PLAN_TYPE !== profileType &&
        !isHeatmapOn &&
        !collection &&
        routes.length === 1
      );
    }, [
      collection,
      isHeatmapOn,
      isVolumeOverlayOn,
      profileType,
      routes.length,
    ]);

    if (!isProfileSelected) return null;

    return (
      <View className={styles.markerContainer}>
        <View>
          <Grid container className={styles.container}>
            {routes.length > 6 ? (
              <Grid
                item
                container
                xs
                className={clsx(styles.spacing)}
                direction={"row"}
              >
                <RouteLabel routeCode={"M"} />
              </Grid>
            ) : (
              routes.map((route, index) => (
                <Grid
                  key={index}
                  item
                  container
                  xs={routes.length >= 3 ? 4 : 12 / routes.length}
                  className={clsx(styles.spacing)}
                  direction={"row"}
                >
                  <RouteLabel
                    routeCode={route}
                    collection={collection}
                    postcode={postcode}
                  />
                  {showVolume() && (
                    <RouteVolumes
                      routeCode={route}
                      postcode={postcode}
                      individual={individual}
                      showNoVolume={showNoVolume}
                    />
                  )}
                </Grid>
              ))
            )}
          </Grid>
        </View>
        {showArrow && (
          <View className={styles.arrowContainer}>
            <View className={styles.arrow} />
          </View>
        )}
      </View>
    );
  }
);
